import axios from "axios"

const baseURL =
    process.env.NODE_ENV !== "production"
        ? process.env.VUE_APP_SERVER_URL + "/api"
        : process.env.VUE_APP_SERVER_LIVE_URL + "/api"

const http = axios.create({
    baseURL,
})

const serverURL =
    process.env.NODE_ENV !== "production"
        ? process.env.VUE_APP_SERVER_URL
        : process.env.VUE_APP_SERVER_LIVE_URL

/**
 * Detect subdomain from URL hostname.
 * Only works for localhost patterns to avoid picking wrong tenant from production domains.
 * For production, rely on stored data or API responses instead.
 */
const getSubdomainFromURL = () => {
    try {
        const hostname = window.location.hostname
        const parts = hostname.split(".")
        
        // Only detect subdomain from localhost (local development only)
        // Skip production domains like hrms.opticalc.in to avoid picking wrong tenant
        if (parts.length >= 2 && parts[parts.length - 1] === "localhost") {
            const sub = parts[0]
            if (sub && sub !== "www" && sub !== "localhost") {
                return sub
            }
        }
    } catch (_) { /* ignore */ }
    return null
}

const getSubdomain = () => {
    // 1. Try Vuex store (most up-to-date after login)
    try {
        // Lazy require to avoid circular dependency (store/auth.js imports http.js)
        const store = require("@/store").default
        if (store && store.state && store.state.auth && store.state.auth.tenant) {
            const tenant = store.state.auth.tenant
            if (tenant.subdomain) return tenant.subdomain
        }
    } catch (e) {
        console.warn("Could not read tenant from store:", e.message)
    }

    // 2. Fallback: localStorage (persists across tabs & sessions)
    const lsSub = localStorage.getItem("TENANT_SUBDOMAIN")
    if (lsSub) return lsSub

    // 3. Fallback: sessionStorage (per-tab, survives refresh)
    const ssSub = sessionStorage.getItem("TENANT_SUBDOMAIN")
    if (ssSub) return ssSub

    // 4. Fallback: detect from URL (works when user is on subdomain.domain.com)
    return getSubdomainFromURL()
}

http.interceptors.request.use((req) => {
    let token = localStorage.getItem("AUTH_TOKEN")
    if (token && req.headers) {
        req.headers.Authorization = `Bearer ${token}`
    }

    // Add Tenant Header
    if (process.env.VUE_APP_MULTI_TENANT_ENABLED === "true") {
        const subdomain = getSubdomain()
        if (subdomain && subdomain !== process.env.VUE_APP_DEFAULT_SUBDOMAIN) {
            req.headers["X-Tenant-Subdomain"] = subdomain
        }
    }

    return req
})

http.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 429) {
            console.error("Rate limit exceeded. Please try again later.")
            // You could emit an event or use a global store action to show a toast here
        }
        return Promise.reject(error)
    }
)

export { http, serverURL, baseURL }
